const BASE_URL = 'https://pretiaar.com';

export default {
  seo: {
    default: {
      title: 'AR謎解きゲーム by Pretia',
      description:
        'プレティア・テクノロジーズ株式会社が提供するAR謎解きゲームの予約サイトです。プレティア・テクノロジーズ株式会社は、ARを活用したエンターテイメントとARクラウドの開発を行っています。',
      ogImage: `${BASE_URL}/apple-touch-icon.png`,
      ogUrl: `${BASE_URL}/`,
      favicon: `/favicon.ico`
    },
    games: {
      '0': {},
      '1': {
        title: `サラと謎のハッカークラブ2`,
        description:
          'ハッカークラブの新メンバーになったあなたを待ち受けるのは、被害総額100億円の大事件！？さらに進化した“HACKPAD（ハックパッド）”を使って、サラ達と一緒に渋谷中に仕掛けられた謎を解こう。あなたは事件の真相まで辿り着くことができるだろうか？',
        ogImage: `${BASE_URL}/images/social-banner-1.jpg`,
        ogUrl: `${BASE_URL}/games/1`
      },
      '2': {
        title: `サラと謎のハッカークラブ`,
        description:
          'あなたのもとに「ハッカークラブ」という組織のメンバーを名乗る少女から突然メッセージが届く。「ハッカークラブの一員になって、私たちと一緒にサイバー攻撃から人びとを守りませんか？」不思議に思いつつも興味本位で入団テストの場所に向かったあなたは…？',
        ogImage: `${BASE_URL}/images/social-banner-2.jpg`,
        ogUrl: `${BASE_URL}/games/2`
      },
      '3': {
        title: `PSYCHO-PASS サイコパス 渋谷サイコハザード`,
        description:
          'プレティア・テクノロジーズが運営するAR謎解きゲーム『PSYCHO-PASS サイコパス 渋谷サイコハザード』。2020年1月21日より渋谷エリアにて開催。主人公であるあなたは、監視官候補生となり狡噛慎也・常守朱とともに、S区のエリアストレスの謎を解き明かしていく新感覚の体験型ゲーム。',
        ogDescription:
          '2020年1月21日より渋谷エリアで開催。あなたは監視官候補生となって、狡噛・常守とS区エリアストレスの謎を捜査する体験型ゲーム。',
        ogImage: `${BASE_URL}/images/social-banner-3.jpg`,
        ogUrl: `${BASE_URL}/games/3`,
        favicon: `/images/favicon-3.ico`
      },
      '6': {
        title: `#コンパスAR謎解き`,
        description:
          'AR（拡張現実）を利用した謎解きゲームMystery of Mirage Message。君はこの謎を解き明かせるか。',
        ogDescription:
          'AR（拡張現実）を利用した謎解きゲームMystery of Mirage Message。君はこの謎を解き明かせるか。',
        ogImage: `${BASE_URL}/images/social-banner-6.png`,
        ogUrl: `${BASE_URL}/games/6`,
        favicon: `/images/favicon-6.ico`
      },
      '7': {
        title: `#コンパスAR謎解き`,
        description:
          'AR（拡張現実）を利用した謎解きゲームMystery of Mirage Message。君はこの謎を解き明かせるか。',
        ogDescription:
          'AR（拡張現実）を利用した謎解きゲームMystery of Mirage Message。君はこの謎を解き明かせるか。',
        ogImage: `${BASE_URL}/images/social-banner-6.png`,
        ogUrl: `${BASE_URL}/games/7`,
        favicon: `/images/favicon-6.ico`
      },
      '8': {
        title: `#コンパスAR謎解き`,
        description:
          'AR（拡張現実）を利用した謎解きゲームMystery of Mirage Message。君はこの謎を解き明かせるか。',
        ogDescription:
          'AR（拡張現実）を利用した謎解きゲームMystery of Mirage Message。君はこの謎を解き明かせるか。',
        ogImage: `${BASE_URL}/images/social-banner-6.png`,
        ogUrl: `${BASE_URL}/games/8`,
        favicon: `/images/favicon-6.ico`
      },
    }
  }
};
